import React from 'react';

import Banner from '../../components/Banner';
import ArticleSpreader from '../../components/ArticleSpreader';
import Paragraph from '../../components/Paragraph';
import ParagraphWithImage from '../../components/ParagraphWithImage';
import Accentuation from '../../components/Accentuation';
import Fact from '../../components/Fact';
import Quote from '../../components/Quote';
import RightBanner from '../../components/RightBanner';
import Slider from '../../components/Slider';
import Roles from '../../components/Roles';
import LeftBanner from '../../components/LeftBanner';
import Article from '../../components/Article';
import EndSpreader from '../../components/EndSpreader';
import MoreArticles from '../../components/MoreArticles';
import BarChart from '../../components/BarChart';

import { Helmet } from 'react-helmet';

const GRAPHIC_DATA = {
  data: [
    {
      year: '2014',
      'трлн руб.': 4.4,
      ['трлн руб.' + 'Color']: '#c83743',
    },
    {
      year: '2015',
      'трлн руб.': 6.15,
      ['трлн руб.' + 'Color']: '#c83743',
    },
    {
      year: '2016',
      'трлн руб.': 6.24,
      ['трлн руб.' + 'Color']: '#c83743',
    },
    {
      year: '2017',
      'трлн руб.': 7.09,
      ['трлн руб.' + 'Color']: '#c83743',
    },
    {
      year: '1 пол.2018',
      'трлн руб.': 7.72,
      ['трлн руб.' + 'Color']: '#c83743',
    },
  ],
  indexBy: 'year',
  keys: ['трлн руб.'],
  axisBottom: {
    orient: 'bottom',
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: 'время',
    legendPosition: 'center',
    legendOffset: 36,
  },
  axisLeft: {
    orient: 'left',
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: 'объем',
    legendPosition: 'center',
    legendOffset: -40,
  },
  labelTextColor: '#FFFFFF',
};

const GRAPHIC_DATA_1 = {
  data: [
    {
      year: '2016',
      '$1-5 млн': 62.623,
      ['$1-5 млн' + 'Color']: '#c83743',
      '$5-100 млн': 15.682,
      ['$5-100 млн' + 'Color']: '#378cc8',
      '>$100 млн': 9.01,
      ['>$100 млн' + 'Color']: '#37c874',
    },
    {
      year: '2017',
      '$1-5 млн': 109.081,
      ['$1-5 млн' + 'Color']: '#c83743',
      '$5-100 млн': 21.759,
      ['$5-100 млн' + 'Color']: '#378cc8',
      '>$100 млн': 8.54,
      ['>$100 млн' + 'Color']: '#37c874',
    },
    {
      year: '2018',
      '$1-5 млн': 143.892,
      ['$1-5 млн' + 'Color']: '#c83743',
      '$5-100 млн': 27.293,
      ['$5-100 млн' + 'Color']: '#378cc8',
      '>$100 млн': 9.8,
      ['>$100 млн' + 'Color']: '#37c874',
    },
  ],
  indexBy: 'year',
  keys: ['$1-5 млн', '$5-100 млн', '>$100 млн'],
  axisBottom: {
    orient: 'bottom',
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: 'время',
    legendPosition: 'center',
    legendOffset: 36,
  },
  axisLeft: {
    orient: 'left',
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: 'объем',
    legendPosition: 'center',
    legendOffset: -40,
  },
  labelTextColor: '#FFFFFF',
};

const OverviewPage = props => (
  <div>
    <Helmet>
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Private Banking - от финансов до стиля жизни - Специальный проект Alfa Private"
      />
      <meta content="Private Banking в России" property="og:description" />
      <meta
        property="og:url"
        content="http://special.kommersant.ru/alfa-private/"
      />
      <meta
        property="og:image"
        content="http://special.kommersant.ru/alfa-private/images/sharing4.jpg"
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="article:published_time" content="2018-11-09" />
      <title>
        Private Banking - от финансов до стиля жизни - Специальный проект Alfa
        Private
      </title>
    </Helmet>
    <Article
      banner={
        <Banner
          title="Private Banking - от финансов до стиля жизни"
          backgroundImage="images/banners/bg.jpg"
        />
      }
      location={props.location}
      showSocialSharing
    >
      {[
        {
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  <img src="images/media/zahod1.jpg" width="100%" />
                </Paragraph>
                <Paragraph>
                  В&nbsp;жизни каждого бизнесмена наступает момент, когда
                  необходимо решать вопрос, как вывести бизнес на&nbsp;новый
                  уровень или что делать с&nbsp;генерируемым им&nbsp; денежным
                  потоком. Крупный капитал требует от&nbsp;его обладателя
                  своевременного и&nbsp; профессионального решения специфических
                  задач, ключевая из&nbsp;которых&nbsp;&mdash; его сохранение
                  для будущего поколения. Не&nbsp;стоит экспериментировать
                  и&nbsp;самостоятельно искать ответы, лучше воспользоваться
                  помощью профессионалов. В&nbsp;Private Banking не&nbsp; только
                  помогут сохранить деньги и&nbsp;решить налоговые вопросы,
                  но&nbsp;и&nbsp;защитят частную жизнь.
                </Paragraph>

                <Paragraph>
                  Сервис частного банковского обслуживания уже давно стал
                  неотъемлемой частью любого крупного банка&nbsp;&mdash; как
                  западного, так и&nbsp;российского. Альфа-Банк считается
                  признанным лидером в&nbsp;этом сегменте.{' '}
                  <Accentuation>
                    По&nbsp;данным журнала Forbes,{' '}
                    <a
                      href="https://bs.serving-sys.com/serving/adServer.bs?cn=trd&mc=click&pli=26540508&PluID=0&ord=%%RANDOM%%"
                      target="_blank"
                    >
                      {' '}
                      Альфа Private
                    </a>{' '}
                    по&nbsp;итогам последних лет объявлен лучшим российским
                    частным банком для состоятельных клиентов.{' '}
                  </Accentuation>
                </Paragraph>

                <Paragraph>
                  <Quote>
                    30 октября аналитическое агентство Frank RG&nbsp;представило
                    исследование &laquo;Private Banking
                    в&nbsp;России-2018&raquo;. По&nbsp;итогам ежегодного
                    интервьюирования лидирующих компаний в&nbsp;сегменте Private
                    Banking, а&nbsp;также их&nbsp;клиентов, Frank
                    RG&nbsp;назвала Альфа Private самым динамично развивающимся
                    private-банком в&nbsp;России.
                  </Quote>
                </Paragraph>

                <Paragraph>
                  Ключевая задача этого подразделения заключается
                  в&nbsp;обслуживании высокосостоятельных клиентов и&nbsp;членов
                  их&nbsp;семей, возможности и&nbsp;потребности которых
                  разнообразнее, чем у&nbsp;обычных граждан. &laquo;Перечень
                  вопросов, которые мы&nbsp;решаем для наших клиентов,
                  существенно шире и, безусловно, выходит за&nbsp;рамки только
                  доверительного управления&raquo;,&nbsp;&mdash; отмечает
                  управляющий директор Альфа Private Катерина Милеева.
                  Персональный финансовый советник подберет как продукты
                  банковского обслуживания, ставшие привычными (депозиты,
                  накопительные счета, кредиты, ячейки и т. д.), и&nbsp;готовые
                  инвестиционные предложения, так и&nbsp;поможет выбрать
                  индивидуальную стратегию в&nbsp;рамках доверительного
                  управления, а&nbsp;также проконсультирует по&nbsp;экзотическим
                  инвестиционным продуктам (предметы коллекционирования,
                  драгоценные камни и&nbsp;металлы и&nbsp;многое другое). При
                  этом услуги для всех членов семьи будут предложены
                  на&nbsp;индивидуальных условиях.
                </Paragraph>

                <Fact source="По данным журнала Forbes">
                  Альфа Private по итогам 2017 года признан лучшим российским
                  частным банком для состоятельных клиентов
                </Fact>
                <Paragraph>
                  Одними инвестициями задачи <b>Private Banking</b>{' '}
                  не&nbsp;ограничиваются. Клиент Альфа Private может получить
                  консультационные услуги по&nbsp;вопросам покупки движимого
                  и&nbsp;недвижимого имущества, налогообложения, наследования,
                  а&nbsp;также широкий спектр юридических услуг.{' '}
                  <Accentuation>
                    <a
                      href="https://bs.serving-sys.com/serving/adServer.bs?cn=trd&mc=click&pli=26540508&PluID=0&ord=%%RANDOM%%"
                      target="_blank"
                    >
                      Lifestyle management
                    </a>{' '}
                    поможет с организацией бытовых вопросов во всех сферах жизни
                    клиента и его семьи: туризм, досуг, здоровье, образование,
                    мероприятия.
                  </Accentuation>{' '}
                  Исходя из&nbsp;пожеланий, менеджер посодействует в&nbsp;поиске
                  подходящего учебного заведения для детей, а&nbsp;для родителей
                  подберет мероприятия высокого уровня, на&nbsp;которых можно
                  получить актуальные знания и&nbsp;найти единомышленников
                  и&nbsp;партнеров.
                </Paragraph>
                <Paragraph>
                  <Quote
                    author={{
                      photo: 'images/media/mileeva-2.jpg',
                      nick: 'Катерина Милеева',
                      job: 'Альфа Private',
                      position:
                        'управляющий директор Альфа Private Катерина Милеева',
                    }}
                  >
                    &laquo;Это не&nbsp;просто работа с&nbsp;клиентом. Это взгляд
                    на&nbsp;его семью, его бизнес, вопросы, касающиеся
                    не&nbsp;только банковского сервиса или инвестиционного
                    консультирования, но&nbsp;и&nbsp;нефинансовые задачи:
                    lifestyle management, вопросы наследования, структурирования
                    активов, альтернативные инвестиции&nbsp;&mdash; перечень
                    очень широк&raquo;.
                  </Quote>
                </Paragraph>
                <Paragraph>
                  Важной отличительной особенностью обслуживания состоятельных
                  клиентов от&nbsp;розничных кроется в&nbsp;том, что
                  не&nbsp;клиент ищет необходимый продукт, а&nbsp;сам банк
                  предлагает ему подходящие решения, в&nbsp;которых используется
                  вся полнота услуг и&nbsp;дополнительно предложения группы
                  компаний и&nbsp;других партнеров.
                </Paragraph>
              </ArticleSpreader>

              <Paragraph>
                <RightBanner image="images/media/pen1.jpg">
                  Клиент получает индивидуальный сервис: финансовый советник -
                  это персональный банкир, который всегда на связи
                </RightBanner>
              </Paragraph>
              <ArticleSpreader>
                <Paragraph>
                  Размещая деньги в&nbsp;банке, клиент может рассчитывать
                  не&nbsp;только на&nbsp;уникальные решения,
                  но&nbsp;и&nbsp;на&nbsp;индивидуальный сервис. Ему больше
                  не&nbsp;нужно ждать, когда освободится менеджер, поскольку
                  финансовый советник&nbsp;&mdash; это персональный банкир,
                  который всегда на&nbsp;связи. К&nbsp;тому&nbsp;же при встрече
                  общение ведется в&nbsp;удобном и&nbsp;тихом офисе или
                  в&nbsp;любом другом месте, где пожелает состоятельный клиент.
                  В&nbsp;случае если появилась потребность в&nbsp;решении
                  вопросов за&nbsp;границей, персональный менеджер может
                  вылететь в&nbsp;любую страну мира и&nbsp;помочь в&nbsp;решении
                  задачи. Но&nbsp;Альфа-Банк всегда был на&nbsp;шаг впереди
                  в&nbsp;технологиях, поэтому сегодня клиент в&nbsp;любой момент
                  может получить полноценную консультацию от&nbsp;удаленного
                  финансового советника, надев VR-очки.
                </Paragraph>
              </ArticleSpreader>
            </div>
          ),
        },
        {
          title: 'Швейцарская начинка',
          banner: (
            <Banner
              title="Private Banking: обзор"
              backgroundImage="images/banners/bg.jpg"
            />
          ),
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  Private Banking зародился в&nbsp;Швейцарии более двух веков
                  назад. Швейцарские банки первыми начали популяризировать
                  принцип эксклюзивности в&nbsp;обслуживании состоятельных
                  клиентов. Основу их&nbsp;бизнеса на&nbsp;начальном этапе
                  развития составил французский капитал, из-за политических
                  событий во&nbsp;Франции в&nbsp;XVII&ndash;XVIII искавший тихую
                  гавань, которой и&nbsp;стала соседняя страна. Впоследствии
                  услугами швейцарских банков начали пользоваться и&nbsp;другие
                  европейские частные капиталы, что позволило небогатой
                  Швейцарии стать центром банковского обслуживания
                  не&nbsp;только Европы, но&nbsp;и&nbsp;всего мира в&nbsp;целом.
                  Вскоре подобные структуры стали появляться во&nbsp;многих
                  других странах.
                </Paragraph>
              </ArticleSpreader>
              <Paragraph>
                <Slider
                  title="Хронология Private Banking"
                  slides={[
                    {
                      title: 'XVIII век',
                      image: 'images/media/house.jpg',
                      description:
                        'Появление первого швейцарского частного банка.',
                    },
                    {
                      title: '1805 год',
                      image: 'images/media/pictet.jpg',
                      description:
                        'Основание швейцарской частной банкирской фирмы Pictet & Cie',
                    },
                    {
                      title: '1934 год',
                      image: 'images/media/swissbank1.jpg',
                      description:
                        'Принят закон о банковской деятельности, положивший начало банковской тайне в Швейцарии',
                    },
                    {
                      title: '1999 год',
                      image: 'images/media/bony.jpg',
                      description:
                        'Дело об отмывании российских денег через Bank of New York',
                    },
                    {
                      title: '2001 год',
                      image: 'images/media/cb.jpg',
                      description:
                        'ЦБ разрешил россиянам открытие счетов за границей',
                    },
                    {
                      title: '2004 год',
                      image: 'images/media/arb.jpg',
                      description:
                        'Создание в России Комитета по частному банковскому обслуживанию АРБ',
                    },
                    {
                      title: '2005 год',
                      image: 'images/media/millionaire1.jpg',
                      description:
                        'Количество долларовых миллионеров в России превысило 100 тыс человек',
                    },
                    {
                      title: '2006 год',
                      image: 'images/media/alfaprivate2006-1.jpg',
                      description:
                        'В Альфа-Банке появилось подразделение по работе с состоятельными клиентами - А-Клуб',
                    },
                    {
                      title: '2015 год',
                      image: 'images/media/roubles_1.jpg',
                      description: 'Первый этап амнистии капитала в России',
                    },
                    {
                      title: '2017 год',
                      image: 'images/media/alfaprivate-logo-full.jpg',
                      description: 'А-Клуб преобразован в Альфа Private',
                    },
                    {
                      title: '2018 год',
                      image: 'images/media/roubles2_1.jpg',
                      description: 'Второй этап амнистии капитала в России',
                    },
                  ]}
                />
              </Paragraph>
              <ArticleSpreader>
                <Paragraph>
                  Впрочем, в&nbsp;каждой стране этот бизнес имеет характерные
                  черты, которые зависят от&nbsp;особенностей правового
                  регулирования. Так, в&nbsp;родоначальнице этого сервиса
                  Швейцарии Private Banking решает задачу не&nbsp;накопления,
                  а&nbsp;сохранения капитала, к&nbsp;тому&nbsp;же там
                  гарантируют конфиденциальность обслуживания. Последнее было
                  ключевой причиной высокой популярности швейцарских банков
                  у&nbsp;российских олигархов в&nbsp;начале 90-х. Однако из-за
                  скандалов с&nbsp;налоговыми органами США, которые произошли
                  в&nbsp;начале XXI века, спрос на&nbsp;швейцарскую банковскую
                  тайну начал снижаться. Тем не&nbsp;менее, Швейцария продолжает
                  удерживать лидирующие позиции в&nbsp;этом сегменте.
                  По&nbsp;оценкам KPMG, по&nbsp;итогам 2017 года швейцарские
                  банки управляют активами клиентов на&nbsp;сумму 2,62 трлн
                  швейцарских франков.
                </Paragraph>
              </ArticleSpreader>
              <ParagraphWithImage image="images/media/clock1.jpg">
                В&nbsp;Великобритании Private Banking выполняет роль
                казначейства, а&nbsp;также решает проблемы наследования.
                По&nbsp;британским законам, если наследственная масса состоит
                из&nbsp;объектов, расположенных на&nbsp;территории Соединенного
                Королевства, а&nbsp;их&nbsp;оценочная стоимость превышает
                &#163;325 тыс., то&nbsp;ставка налога составит 40%. Поэтому
                на&nbsp;прилегающих к&nbsp;Британии островах создаются
                специальные трасты, на&nbsp;которые оформляется вся недвижимость
                и&nbsp;имущество богатых британцев. Это позволяет потомкам
                избежать уплаты налога при получении наследства. В&nbsp;Германии
                роль семейных офисов сводилась в&nbsp;основном к&nbsp;налоговому
                планированию.
              </ParagraphWithImage>
              <ArticleSpreader>
                <Paragraph>
                  В&nbsp;США основной задачей Private Banking считалась
                  преемственность и&nbsp;филантропия, а&nbsp;также помощь
                  клиентам в&nbsp;заполнении налоговых деклараций. Американская
                  система налогов довольно сложна, а&nbsp;наказания
                  за&nbsp;налоговые преступления очень серьезные. Поэтому
                  состоятельные клиенты начали перекладывать эти обязанности
                  на&nbsp;банки.
                </Paragraph>
                <Roles title="Роли Private Banking в разных странах">
                  {[
                    {
                      title: 'Швейцария',
                      description: 'Сохранение капитала',
                      icon: 'images/roles/switzerland.svg',
                    },
                    {
                      title: 'Великобритания',
                      description: 'Казначейство',
                      icon: 'images/roles/england.svg',
                    },
                    {
                      title: 'США',
                      description: 'Преемственность и филантропия',
                      icon: 'images/roles/usa.svg',
                    },
                  ]}
                </Roles>
              </ArticleSpreader>
            </div>
          ),
        },
        {
          title: 'Российский подход',
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  Российский рынок частного банковского
                  обслуживания&nbsp;&mdash; один из&nbsp;самых молодых
                  в&nbsp;Европе и&nbsp;насчитывает около двух десятилетий. Еще
                  в&nbsp;90-е годы каждый крупный российский банк работал
                  с&nbsp;VIP-клиентами, но&nbsp;это были в&nbsp;первую очередь
                  владельцы банков, их&nbsp;семьи, а&nbsp;также их&nbsp;друзья.
                  Как полноценное направление бизнеса оно
                  не&nbsp;воспринималось, поскольку общее число
                  высокосостоятельных клиентов было незначительным,
                  а&nbsp;сбережения они предпочитали хранить в&nbsp;западных
                  банках вдали от&nbsp;неопределенностей тех лет.
                </Paragraph>
                <Fact>
                  Альфа-Банк оказывает услуги Private Banking с<br />
                  <span
                    style={{
                      fontSize: '40px',
                      paddingTop: '12px',
                      display: 'inline-block',
                    }}
                  >
                    2006 года
                  </span>
                </Fact>
                <Paragraph>
                  Ситуация начала меняться лишь в начале XXI века, когда на фоне
                  бурного роста российской экономики, выросло общее число
                  состоятельных людей.{' '}
                  <Accentuation>
                    По&nbsp;оценкам швейцарского банка Credit Suisse, совокупное
                    благосостояние россиян увеличилось с&nbsp;2000 года
                    по&nbsp;середину 2018 года в&nbsp;семь раз и&nbsp;составило
                    $2,2 трлн. Общее число долларовых миллионеров достигло 172
                    тыс., а&nbsp;миллиардеров превысило семь десятков.{' '}
                  </Accentuation>
                </Paragraph>
                <Paragraph>
                  Толчком для появления полноценного российского Private Banking
                  стала либерализация российского законодательства с&nbsp;точки
                  зрения движения капитала. Весной 2001 года российские частные
                  инвесторы получили возможность перечислять за&nbsp;рубеж
                  до&nbsp;$75 тыс. в&nbsp;год для приобретения иностранных
                  ценных бумаг.&nbsp;Осенью того же года ЦБ разрешил физическим
                  лицам открывать счета в иностранных банках, хотя и с рядом
                  оговорок.
                </Paragraph>
              </ArticleSpreader>
              <Paragraph>
                <LeftBanner image="images/banners/black-banner.jpg">
                  Рынок Private Banking вырос за последние три года на 75% и по
                  итогам первого полугодия 2018 года его объем составил 7,7 трлн
                  руб.
                </LeftBanner>
              </Paragraph>
              <ArticleSpreader>
                <Paragraph>
                  Первым премиальное обслуживание запустил в&nbsp;России
                  &laquo;Ситибанк&raquo;. В&nbsp;2002 году &laquo;дочка&raquo;
                  американского банка предложила российским клиентам программу
                  Citigold с&nbsp;полноценными услугами Private Banking.
                  В&nbsp;течение последующих нескольких лет специализированные
                  премиальные программы запустили и&nbsp;другие банки
                  с&nbsp;иностранным участием&nbsp;&mdash;
                  &laquo;Дойчебанк&raquo;, &laquo;Райффайзенбанк&raquo;,
                  &laquo;ЮниКредит&raquo;. Среди первых российских банков,
                  предложивших услугу Private Banking, был Альфа-Банк, который
                  оказывает их&nbsp;с&nbsp;2006 года. В&nbsp;апреле 2017 года
                  это направление бизнеса было переименовано в&nbsp;
                  <a
                    href="https://bs.serving-sys.com/serving/adServer.bs?cn=trd&mc=click&pli=26540508&PluID=0&ord=%%RANDOM%%"
                    target="_blank"
                  >
                    Альфа Private
                  </a>
                  , и&nbsp;с&nbsp;того момента активы выросли практически
                  в&nbsp;2 раза, при этом 90% прироста составили средства
                  клиентов из&nbsp;государственных и&nbsp;западных банков.
                </Paragraph>
                <Paragraph>
                  <BarChart
                    data={GRAPHIC_DATA}
                    title="Как менялся объем рынка Private Banking в России"
                    source="По данным Frank RG"
                  />
                </Paragraph>
                <Paragraph>
                  Весь сегмент Private Banking России также увеличивается
                  высокими темпами. По&nbsp;данным исследования аналитического
                  агентства Frank RG, этот рынок вырос за&nbsp;последние четыре
                  года на&nbsp;64% и&nbsp;в&nbsp;2017 году его объем составил
                  7,2&nbsp;трлн&nbsp;рублей. Этому способствовали изменения
                  в&nbsp;международной и&nbsp;российской экономической среде.
                  В&nbsp;последние годы в&nbsp;мире активизировался процесс
                  деофшоризации, а&nbsp;санкции, объявленные западными странами,
                  повысили риск размещения средств в&nbsp;иностранном банке для
                  российских бизнесменов. Да&nbsp;и&nbsp;сами западные банки
                  ужесточили требования к&nbsp;российским клиентам
                  и&nbsp;с&nbsp;меньшей охотой стали обслуживать их.
                </Paragraph>
                <Fact source="По данным Credit Suisse">
                  С 2000 по середину 2018 годов совокупное благосостояние
                  россиян увеличилось в семь раз и составило
                  <br />
                  <span
                    style={{
                      fontSize: '40px',
                      paddingTop: '12px',
                      display: 'inline-block',
                    }}
                  >
                    $2,2 трлн
                  </span>
                </Fact>
                <Paragraph>
                  Не&nbsp;последнюю роль в&nbsp;популяризации российского рынка
                  сыграла амнистия капитала, объявленная российской властью.
                  Первый ее&nbsp;этап проводился с&nbsp;1 июля 2015 года
                  по&nbsp;30 июня 2016 года&nbsp;&mdash; всем желающим тогда
                  было предложено подавать в&nbsp;налоговую инспекцию
                  спецдекларацию с&nbsp;информацией об&nbsp;имуществе (земля
                  и&nbsp;другая недвижимость, транспорт, ценные бумаги, доли
                  в&nbsp;бизнесе), о&nbsp;контролируемых иностранных компаниях
                  (КИК) и&nbsp;о&nbsp;счетах в&nbsp;зарубежных банках.
                  В&nbsp;ответ власти обещали режим налоговой тайны
                  и&nbsp;освобождение от&nbsp;ответственности всех видов,
                  платить налоги с&nbsp;раскрытых активов не&nbsp;требовалось.{' '}
                  <Accentuation>
                    В&nbsp;начале 2018 года был объявлен второй этап амнистии
                    сроком с&nbsp;1&nbsp;марта 2018 года по&nbsp;28 февраля 2019
                    года. Процедура возвращения капитала на&nbsp;родину
                    оказалась нетривиальной задачей, с&nbsp;которой мог
                    справиться не&nbsp;каждый иностранный банк. Поэтому спрос
                    на&nbsp;услуги российских банкиров вырос.
                  </Accentuation>{' '}
                </Paragraph>
                <Paragraph>
                  <Quote>
                    &laquo;Эволюция клиента привела к&nbsp;эволюции
                    отрасли&nbsp;&mdash; поэтому сейчас услуги семейного офиса
                    востребованы как никогда раньше&raquo;
                  </Quote>
                </Paragraph>
                <Paragraph>
                  <BarChart
                    data={GRAPHIC_DATA_1}
                    title="Сколько состоятельных людей в России (тыс. чел.)"
                    source="По данным Credit Suisse Global Wealth Databook, Frank RG"
                  />
                </Paragraph>
                <Paragraph>
                  Вместе с&nbsp;финансовой системой изменились и&nbsp;клиенты
                  банков. По&nbsp;словам Катерины Милеевой, они стали более
                  требовательными, поскольку многие из&nbsp;них успели получить
                  опыт сотрудничества с&nbsp;зарубежными банками, имеющими
                  вековые традиции частного банковского обслуживания. &laquo;Они
                  уже не&nbsp;спрашивают, почему важно продумывать
                  структурирование активов, вопросы наследования, следить
                  за&nbsp;изменениями российского и&nbsp;международного
                  налогового законодательства. Сейчас они, как правило, приходят
                  с&nbsp;уже сформулированным запросом, их&nbsp;интересует
                  не&nbsp;что сделать, а&nbsp;как,&nbsp;&mdash; рассказывает
                  Катерина Милеева. &mdash;&nbsp;Эволюция клиента привела
                  к&nbsp;эволюции отрасли, поэтому сейчас услуги семейного офиса
                  востребованы как никогда раньше&raquo;.
                </Paragraph>
                <EndSpreader />
                <MoreArticles
                  articles={[
                    {
                      title: 'Цифровые капиталы',
                      url: '/digital',
                      background: 'images/media/anons211.jpg',
                    },
                    {
                      title: 'Забота о благосостоянии',
                      url: '/invest',
                      background: 'images/media/anons3.jpg',
                    },
                    {
                      title: 'Наш внутренний девиз — у нас всегда есть решение»',
                      url: '/interview',
                      background: 'images/media/anons4.jpg',
                    },
                  ]}
                />
              </ArticleSpreader>
            </div>
          ),
        },
      ]}
    </Article>
  </div>
);

export default OverviewPage;

// https://react-slick.neostack.com/docs/example/custom-arrows/
// http://nivo.rocks/bar
